<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <h-three title="Color Switcher" />
      </flex-col>
      <flex-col :span="24">
        <paragraph>You can apply color theme to this entire website to see the colors in action. You can also switch colors
          from the navbar.</paragraph>
        <app-color-switcher name="page-color-switcher" />
      </flex-col>
    </flex>
    <colors />
  </container>
</template>
<script>

export default {
  name: 'PageColors'
}
</script>



// WEBPACK FOOTER //
// src/pages/content/colors.vue